module.exports = __webpack_public_path__ + "img/hr-level1_idle_gun_mask.3c6d9fdb.png";